import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Switch} from "react-router-dom/cjs/react-router-dom.min";

import AppHeader from "../appHeader/AppHeader";
import Spinner from "../spinner/Spinner";

const Page404 = lazy(() => import('../pages/404'));
const MainPage = lazy(() => import('../pages/MainPage'));
const EpisodesPage = lazy(() => import('../pages/EpisodesPage'));
const SingleEpisodeLayout = lazy(() => import('../pages/singleEpisodeLayout/SingleEpisodeLayout'));
const SingleCharacterLayout = lazy(() => import('../pages/singleCharacterLayout/SingleCharacterLayout'));
const SinglePage = lazy(() => import('../pages/SinglePage'));



const App = () => {

    return (
        <Router>
            <div className="app">
            <AppHeader/>
            <main>
                <Suspense fallback={<Spinner/>}>
                    <Switch>
                        <Route exact path="/">
                            <MainPage/>
                        </Route>
                        <Route exact path="/episodes">
                            <EpisodesPage/>
                        </Route>
                        <Route exact path="/episodes/:id">
                                <SinglePage Component={SingleEpisodeLayout} dataType='episode'/>
                            </Route>
                            <Route exact path="/characters/:id">
                                <SinglePage Component={SingleCharacterLayout} dataType='character'/>
                            </Route>
                        <Route path="*">
                            <Page404/>
                        </Route>
                    </Switch>
                </Suspense>
            </main>
        </div>
        </Router>
    )
}

export default App;